import React from 'react';
import styles from './CustomPagination.module.css';
import {ReactComponent as PaginationIcon} from '../../assets/icons/icon_arrow_pagination.svg';

type CustomPaginationProps = {
    currentPage: number;
    setPage: Function;
    pageNumber: number;
    isLoading: boolean;
}

const CustomPagination = (props: CustomPaginationProps) => {
    return (
        <div className={styles.containerPagination}>
            { props.currentPage > 0 &&
                <>
                    <button onClick={() => props.setPage(props.currentPage - 1)}>
                        <PaginationIcon className={styles.prevIcon} />
                    </button>
                    <button onClick={() => props.setPage(0)}>1</button>
                </>
            }

            { props.currentPage > 2 &&
                <span>...</span>
            }

            { props.currentPage > 1 &&
                <button onClick={() => props.setPage(props.currentPage - 1)}>{props.currentPage}</button>
            }

            <button className={styles.active}>{props.currentPage + 1}</button>

            { props.currentPage + 2 < props.pageNumber &&
                <button onClick={() => props.setPage(props.currentPage + 1)}>{props.currentPage + 2}</button>
            }

            { props.currentPage + 3 < props.pageNumber &&
                <span>...</span>
            }

            { props.currentPage + 1 < props.pageNumber &&
                <>
                    <button  onClick={() => props.setPage(props.pageNumber - 1)}>{props.pageNumber}</button>
                    <button onClick={() => props.setPage(props.currentPage + 1)}>
                        <PaginationIcon />
                    </button>
                </>
            }
        </div>
    );
}

export default CustomPagination;